import React from 'react';
import Icon from './Icon';

const ExcelIcon = (props) => (
    <Icon {...props}>
        <path
            d="M13 3H6C4.9 3 4 3.9 4 5V19C4 20.1 4.9 21 6 21H8M13 3L19 9M13 3V8C13 8.55 13.45 9 14 9H19M19 9V10M19 14V20H22M10.5 13.5L15.5 19.5M15.5 13.5L10.5 19.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default ExcelIcon;
